// Mock data for Qromo — QR Code Generator + Linktree Premium
// NOTE: All data here is MOCKED (browser-side only). Replaced later by real backend.
import {
  Link2, FileText, Image as ImageIcon, Video, Contact, Wifi, Mail,
  MessageSquare, Phone, UtensilsCrossed, AppWindow, Share2, Music, Globe,
} from "lucide-react";

export const QR_TYPES = [
  { id: "url", label: "Sito Web / Link", icon: Link2, desc: "Collega qualsiasi pagina web", dynamic: true },
  { id: "pdf", label: "PDF", icon: FileText, desc: "Mostra un documento PDF", dynamic: true },
  { id: "images", label: "Galleria Foto", icon: ImageIcon, desc: "Un album di immagini", dynamic: true },
  { id: "video", label: "Video", icon: Video, desc: "YouTube o video caricato", dynamic: true },
  { id: "biopage", label: "Bio Page (Linktree)", icon: Share2, desc: "Tutti i tuoi link in uno", dynamic: true },
  { id: "menu", label: "Menu Digitale", icon: UtensilsCrossed, desc: "Menu sempre aggiornato", dynamic: true },
  { id: "vcard", label: "vCard", icon: Contact, desc: "Biglietto da visita digitale", dynamic: true },
  { id: "wifi", label: "WiFi", icon: Wifi, desc: "Connessione con una scansione", dynamic: false },
  { id: "text", label: "Testo", icon: MessageSquare, desc: "Messaggio di testo semplice", dynamic: false },
  { id: "email", label: "Email", icon: Mail, desc: "Precompila una email", dynamic: false },
  { id: "phone", label: "Telefono", icon: Phone, desc: "Chiamata con un tap", dynamic: false },
  { id: "app", label: "App Store", icon: AppWindow, desc: "Download app iOS/Android", dynamic: true },
  { id: "mp3", label: "Audio / MP3", icon: Music, desc: "Traccia audio o podcast", dynamic: true },
  { id: "social", label: "Social Media", icon: Globe, desc: "Tutti i tuoi social", dynamic: true },
];

export const FRAME_STYLES = [
  { id: "none", label: "Nessuna" },
  { id: "scan-me", label: "Scan Me", text: "SCANSIONAMI" },
  { id: "rounded", label: "Arrotondata", text: "SCANSIONA QUI" },
  { id: "ticket", label: "Ticket", text: "SCOPRI DI PIÙ" },
];

export const DOT_STYLES = [
  { id: "squares", label: "Quadrati" },
  { id: "dots", label: "Punti" },
  { id: "rounded", label: "Arrotondati" },
  { id: "classy", label: "Elegante" },
];

export const COLOR_PRESETS = [
  { id: "classic", fg: "#0B1120", bg: "#FFFFFF" },
  { id: "royal", fg: "#3730E8", bg: "#FFFFFF" },
  { id: "mint", fg: "#059669", bg: "#F0FDF4" },
  { id: "sunset", fg: "#DB2777", bg: "#FFF1F7" },
  { id: "ocean", fg: "#0369A1", bg: "#F0F9FF" },
  { id: "dark", fg: "#10DEB9", bg: "#0B1120" },
];

// ---- Dashboard: my QR codes (mock) ----
export const MY_QRCODES = [
  { id: "q1", name: "Menu Primavera 2025", type: "menu", url: "https://qr.mo/menu-primavera", scans: 1284, unique: 912, status: "active", color: "#3730E8", created: "2025-06-02", lastScan: "2025-07-18" },
  { id: "q2", name: "Portfolio PDF", type: "pdf", url: "https://qr.mo/portfolio", scans: 342, unique: 289, status: "active", color: "#DB2777", created: "2025-05-21", lastScan: "2025-07-17" },
  { id: "q3", name: "Catalogo Prodotti", type: "images", url: "https://qr.mo/catalogo", scans: 876, unique: 654, status: "active", color: "#059669", created: "2025-04-11", lastScan: "2025-07-16" },
  { id: "q4", name: "Video Promo Estate", type: "video", url: "https://qr.mo/promo-estate", scans: 2103, unique: 1744, status: "active", color: "#0369A1", created: "2025-06-29", lastScan: "2025-07-18" },
  { id: "q5", name: "Bio Links @marco", type: "biopage", url: "https://qr.mo/marco", scans: 5420, unique: 3980, status: "active", color: "#7C3AED", created: "2025-03-02", lastScan: "2025-07-18" },
  { id: "q6", name: "WiFi Lounge", type: "wifi", url: "WIFI:T:WPA;S:Lounge;P:*****;;", scans: 418, unique: 390, status: "paused", color: "#0B1120", created: "2025-02-15", lastScan: "2025-07-10" },
];

export const SCAN_TREND = [
  { day: "Lun", scans: 320 }, { day: "Mar", scans: 410 }, { day: "Mer", scans: 380 },
  { day: "Gio", scans: 520 }, { day: "Ven", scans: 690 }, { day: "Sab", scans: 840 }, { day: "Dom", scans: 610 },
];

export const SCAN_DEVICES = [
  { label: "iOS", value: 58, color: "#3730E8" },
  { label: "Android", value: 36, color: "#10DEB9" },
  { label: "Desktop", value: 6, color: "#CBD5E1" },
];

export const SCAN_COUNTRIES = [
  { country: "Italia", flag: "🇮🇹", pct: 71 },
  { country: "Germania", flag: "🇩🇪", pct: 11 },
  { country: "Francia", flag: "🇫🇷", pct: 8 },
  { country: "Spagna", flag: "🇪🇸", pct: 6 },
  { country: "Altro", flag: "🌍", pct: 4 },
];

// ---- Linktree / Bio page builder defaults (mock) ----
export const BIO_THEMES = [
  { id: "aurora", label: "Aurora", bg: "linear-gradient(160deg,#eef2ff 0%,#fce7f3 100%)", card: "#ffffff", text: "#0B1120", btn: "#4f56ff", btnText: "#ffffff" },
  { id: "noir", label: "Noir", bg: "linear-gradient(160deg,#0b1120 0%,#1e293b 100%)", card: "rgba(255,255,255,0.08)", text: "#ffffff", btn: "#10deb9", btnText: "#0B1120" },
  { id: "sunset", label: "Sunset", bg: "linear-gradient(160deg,#fff7ed 0%,#ffe4e6 100%)", card: "#ffffff", text: "#431407", btn: "#f97316", btnText: "#ffffff" },
  { id: "forest", label: "Forest", bg: "linear-gradient(160deg,#ecfdf5 0%,#d1fae5 100%)", card: "#ffffff", text: "#052e16", btn: "#059669", btnText: "#ffffff" },
  { id: "mono", label: "Mono", bg: "#f4f4f5", card: "#ffffff", text: "#18181b", btn: "#18181b", btnText: "#ffffff" },
];

export const DEFAULT_BIO = {
  username: "marco.rossi",
  displayName: "Marco Rossi",
  bio: "Creator · Food & Travel 🍝✈️ · Milano",
  avatar: "https://i.pravatar.cc/200?img=12",
  themeId: "aurora",
  verified: true,
  links: [
    { id: "l1", title: "Il mio nuovo video su YouTube", url: "https://youtube.com", icon: "Youtube", active: true, clicks: 1240, featured: true },
    { id: "l2", title: "Prenota una consulenza", url: "https://calendly.com", icon: "Calendar", active: true, clicks: 540, featured: false },
    { id: "l3", title: "Shop — Merch ufficiale", url: "https://shop.com", icon: "ShoppingBag", active: true, clicks: 980, featured: false },
    { id: "l4", title: "Newsletter settimanale", url: "https://substack.com", icon: "Mail", active: true, clicks: 310, featured: false },
  ],
  socials: [
    { id: "s1", platform: "Instagram", url: "https://instagram.com" },
    { id: "s2", platform: "TikTok", url: "https://tiktok.com" },
    { id: "s3", platform: "Youtube", url: "https://youtube.com" },
    { id: "s4", platform: "Spotify", url: "https://spotify.com" },
  ],
};

// ---- Pricing ----
export const PLANS = [
  {
    id: "free", name: "Free", price: "0", period: "per sempre", highlight: false,
    desc: "Per iniziare con i QR code statici.",
    features: ["QR code statici illimitati", "Download PNG", "3 tipi di contenuto", "Colori base"],
    cta: "Inizia gratis",
  },
  {
    id: "pro", name: "Pro", price: "9", period: "al mese", highlight: true,
    desc: "QR dinamici + Bio page premium.",
    features: ["QR code dinamici illimitati", "Statistiche scansioni in tempo reale", "Tutti i 14 tipi di contenuto", "Logo e colori personalizzati", "Bio page (Linktree) illimitate", "Download SVG, PDF, EPS", "Frame personalizzate"],
    cta: "Prova 14 giorni gratis",
  },
  {
    id: "business", name: "Business", price: "29", period: "al mese", highlight: false,
    desc: "Per team e aziende.",
    features: ["Tutto del piano Pro", "Dominio personalizzato", "Team & multi-utente", "Bulk QR (CSV)", "API & integrazioni", "Supporto prioritario"],
    cta: "Contatta le vendite",
  },
];

export const CLIENTS = ["Talent Garden", "Joe's BBQ", "Caffè Scala", "East Market", "Street", "Panino Perfetto"];

export const FEATURES = [
  { icon: "RefreshCw", title: "QR Dinamici", desc: "Cambia la destinazione quando vuoi, il QR resta lo stesso. Mai più ristampare." },
  { icon: "BarChart3", title: "Statistiche live", desc: "Scansioni, dispositivi, città e orari in tempo reale per ogni codice." },
  { icon: "Palette", title: "Personalizzazione", desc: "Logo, colori, forme e frame. QR che rispecchiano il tuo brand." },
  { icon: "Share2", title: "Bio Page premium", desc: "Una pagina Linktree con tutti i tuoi link, temi e analisi dei clic." },
  { icon: "FileText", title: "14 tipi di contenuto", desc: "Link, PDF, video, galleria foto, menu, vCard, WiFi e molto altro." },
  { icon: "Download", title: "Export pro", desc: "Scarica in PNG, SVG, PDF ed EPS in alta risoluzione per la stampa." },
];

export const FAQS = [
  { q: "Qual è la differenza tra QR statico e dinamico?", a: "Un QR statico contiene i dati fissi: una volta creato non si può modificare. Un QR dinamico punta a un link intermedio che puoi cambiare in qualsiasi momento, senza ristampare il codice, e ti dà le statistiche delle scansioni." },
  { q: "Posso mettere il mio logo dentro il QR?", a: "Sì. Con il piano Pro puoi inserire il tuo logo al centro del QR, scegliere colori personalizzati, forme dei moduli e cornici con call-to-action." },
  { q: "La Bio Page è come Linktree?", a: "Esatto, ma integrata. Crei una pagina con tutti i tuoi link, scegli un tema, e generi automaticamente il QR che porta ad essa. Hai anche le statistiche dei clic su ogni link." },
  { q: "Posso provarlo gratis?", a: "Sì, puoi creare QR statici gratis per sempre. Le funzioni dinamiche e la Bio Page premium hanno 14 giorni di prova gratuita." },
  { q: "I QR code scadono?", a: "No. I QR statici non scadono mai. I QR dinamici restano attivi finché il tuo account è attivo." },
];
